import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"
import { ToastContainer } from "react-toastify"
import { Card, CardBody, Col, Form, FormFeedback, Input, Row } from "reactstrap"
import API_SERVICE from "shared/services/api-services"
import { notification } from "shared/utility/Utility"
import * as Yup from "yup"
import ReactQuill from "react-quill"
import { toolbarOptions } from "pages/Ecommerce/EcommerceOrders/CMSDetails"

function AddQuestion() {
  const [isLoading, setLoading] = useState(false)
  const [segmentList, setSegmentList] = useState([])

  const navigate = useNavigate()

  document.title = "Inventya"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      question: "",
      isActive: null,
      webhookIdentifier: "",
      description: "",
      shortForm: "",
      question_type: null,
      image: null,
      segmentId: null,
      boilerPlateText: "",
    },
    validationSchema: Yup.object({
      // WE can use this later for validation if needed
      question: Yup.string().required("Please Enter Your Question"),
      isActive: Yup.string().required("Please Select Status"),
      webhookIdentifier: Yup.string().required(
        "Please Enter WebhookIdentifier"
      ),
      description: Yup.string().nullable(),
      shortForm: Yup.string().required("Please Enter Short Form"),
      question_type: Yup.string()
        .required("Please Select Type")
        .test("question_type", "Please Select Type", value => {
          return value !== "null"
        }),
      image: Yup.string().required("Please Select Image"),
      segmentId: Yup.string()
        .required("Please Select Segment")
        .test("segmentId", "Please Select Segment", value => {
          return value !== "null"
        }),
      boilerPlateText: Yup.string().test({
        name: "boilerPlateText",
        test: (value, context) => {
          if (
            context.parent.question_type === "SHORT_ANSWER" ||
            context.parent.question_type === "MULTI_CORRECT"
          ) {
            return true
          } else {
            if(!Boolean(value) || value === "<p><br></p>"){
            return context.createError({
              message: "Please Enter Boiler Plate Text",
            })
          }
            else{
              return true
          }
          }
        },
      }),
    }),
    onSubmit: values => {
      const formData = new FormData()
      formData.append("question", values.question)
      formData.append("isActive", values.isActive === "Active" ? true : false)
      formData.append("webhookIdentifier", values.webhookIdentifier)
      formData.append("description", values.description)
      formData.append("shortForm", values.shortForm)
      formData.append("question_type", values.question_type)
      formData.append("segmentId", values.segmentId)
      formData.append("image", values.image)
      formData.append("boilerPlateText", values.boilerPlateText)
      addQuestionAndAnswer(formData)
    },
  })

  const addQuestionAndAnswer = async formData => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.addQuestionAndAnswer(formData)
      notification("success", "Question added successfully")
      validation.resetForm()
      navigate(`/q-n-a/${data.id}`)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }

  const getSegmentList = async () => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.fetchSegmentList()
      setSegmentList(data)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }

  useEffect(() => {
    getSegmentList()
  }, [])

  console.log(validation.errors)

  return (
    <React.Fragment>
      <Form
        className="form-horizontal"
        onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
      >
        <div className="page-content">
          <div className="container-fluid">
            {isLoading ? (
              <Row>
                <Col xs={12}>
                  <Spinners setLoading={setLoading} />
                </Col>
              </Row>
            ) : (
              <>
                <Row>
                  <Col xs={12}>
                    <div className=" h-100 d-sm-flex align-items-center justify-content-between">
                      <h4 className="mb-sm-0 font-size-16 text-uppercase">
                        Question list - Add
                      </h4>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col xs="12">
                    <Card>
                      <CardBody
                        style={{
                          minHeight: "calc(100vh - 230px)",
                        }}
                      >
                        <Row
                          style={{
                            rowGap: "1.5rem",
                          }}
                        >
                          <Col xs="12" sm="12" md="3">
                            <div className=" h-100 d-flex align-items-center justify-content-between">
                              <h4 className="mb-sm-0 font-size-16 text-uppercase">
                                Question Text
                              </h4>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" md="9">
                            <Input
                              name="question"
                              placeholder="Enter question"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.question || ""}
                              invalid={
                                validation.touched.question &&
                                validation.errors.question
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.question &&
                            validation.errors.question ? (
                              <FormFeedback type="invalid">
                                {validation.errors.question}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <div className=" h-100 d-flex align-items-center justify-content-between">
                              <h4 className="mb-sm-0 font-size-16 text-uppercase">
                                Type
                              </h4>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <Input
                              type="select"
                              name="question_type"
                              invalid={
                                validation.touched.question_type &&
                                validation.errors.question_type
                                  ? true
                                  : false
                              }
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.question_type || ""}
                            >
                              <option value={"null"}>Select Type</option>
                              <option value="SHORT_ANSWER">SHORT ANSWER</option>
                              <option value="SINGLE_CORRECT">
                                SINGLE CORRECT
                              </option>
                              <option value="MULTI_CORRECT">
                                MULTI CORRECT
                              </option>
                            </Input>

                            {validation.touched.question_type &&
                            validation.errors.question_type ? (
                              <FormFeedback type="invalid">
                                {validation.errors.question_type}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <div className=" h-100 d-flex align-items-center gap-2 justify-content-end">
                              <h4 className="mb-sm-0 font-size-16 text-uppercase">
                                SEGMENT
                              </h4>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <Input
                              name="segmentId"
                              type="select"
                              invalid={
                                validation.touched.segmentId &&
                                validation.errors.segmentId
                                  ? true
                                  : false
                              }
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.segmentId || ""}
                            >
                              <option value={"null"}>Select Segment</option>
                              {segmentList &&
                                segmentList.map(item => {
                                  return (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  )
                                })}
                            </Input>
                            {validation.touched.segmentId &&
                            validation.errors.segmentId ? (
                              <FormFeedback>
                                {validation.errors.segmentId}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <div className=" h-100 d-flex align-items-center justify-content-between">
                              <h4 className="mb-sm-0 font-size-16 text-uppercase">
                                Status
                              </h4>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" md="9">
                            <div className="d-flex gap-3">
                              <div className="d-flex gap-1">
                                <input
                                  type="radio"
                                  name="isActive"
                                  value="true"
                                  checked={
                                    validation.values.isActive === "true"
                                  }
                                  onClick={() =>
                                    validation.setFieldValue("isActive", "true")
                                  }
                                />
                                Active
                              </div>
                              <div className="d-flex gap-1">
                                <input
                                  type="radio"
                                  name="isActive"
                                  value="false"
                                  checked={
                                    validation.values.isActive === "false"
                                  }
                                  onClick={() =>
                                    validation.setFieldValue(
                                      "isActive",
                                      "false"
                                    )
                                  }
                                />
                                Inactive
                              </div>
                            </div>
                            {validation.touched.isActive &&
                            validation.errors.isActive ? (
                              <div
                                style={{
                                  color: "#f46a6a",
                                  fontSize: "0.675rem",
                                  marginTop: "0.25rem",
                                }}
                              >
                                {validation.errors.isActive}
                              </div>
                            ) : null}
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <div className=" h-100 d-flex align-items-center justify-content-between">
                              <h4 className="mb-sm-0 font-size-16 text-uppercase">
                                WEBHOOKIDENTIFIER
                              </h4>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <Input
                              name="webhookIdentifier"
                              value={validation.values.webhookIdentifier}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.webhookIdentifier &&
                                validation.errors.webhookIdentifier
                                  ? true
                                  : false
                              }
                              placeholder="Enter WebhookIdentifier..."
                            />
                            {validation.touched.webhookIdentifier &&
                            validation.errors.webhookIdentifier ? (
                              <FormFeedback type="invalid">
                                {validation.errors.webhookIdentifier}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <div className=" h-100 d-flex align-items-center justify-content-end">
                              <h4 className="mb-sm-0 font-size-16 text-uppercase p-0">
                                Question short Text
                              </h4>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <Input
                              name="shortForm"
                              value={validation.values.shortForm}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.shortForm &&
                                validation.errors.shortForm
                                  ? true
                                  : false
                              }
                              placeholder="Enter Question Short Text..."
                            />
                            {validation.touched.shortForm &&
                            validation.errors.shortForm ? (
                              <FormFeedback type="invalid">
                                {validation.errors.shortForm}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <div className=" h-100 d-flex align-items-center justify-content-between">
                              <h4 className="mb-sm-0 font-size-16 text-uppercase">
                                Question description
                              </h4>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" md="9">
                            <Input
                              name="description"
                              type="textarea"
                              rows="5"
                              value={validation.values.description || ""}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.description &&
                                validation.errors.description
                                  ? true
                                  : false
                              }
                              placeholder="Enter Question Description..."
                            />
                            {validation.touched.description &&
                            validation.errors.description ? (
                              <FormFeedback type="invalid">
                                {validation.errors.description}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col xs="12" sm="12" md="3">
                            <div className=" h-100 d-flex align-items-center justify-content-between">
                              <h4 className="mb-sm-0 font-size-16 text-uppercase">
                                Boiler Plate Text
                              </h4>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" md="9">
                            <ReactQuill
                              placeholder={`${"Write your answer here..."}`}
                              modules={{
                                toolbar: toolbarOptions,
                              }}
                              style={{ backgroundColor: "white" }}
                              theme="snow"
                              value={validation.values.boilerPlateText || ""}
                              onChange={value => {
                                validation.setFieldValue(
                                  "boilerPlateText",
                                  value
                                )
                              }}
                            />
                         {
                              validation.touched.boilerPlateText &&
                              validation.errors.boilerPlateText ? (
                                <div
                                style={{
                                  color: "#f46a6a",
                                  fontSize: "0.675rem",
                                  marginTop: "0.25rem",
                                }}
                              >
                                  {validation.errors.boilerPlateText}
                               </div>
                              ) : null
                           }
                          </Col>
                          
                          <Col xs="12" sm="12" md="3">
                            <div className=" h-100 d-flex align-items-center justify-content-between">
                              <h4 className="mb-sm-0 font-size-16 text-uppercase">
                                Question Image
                              </h4>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" md="9">
                            <Input
                              type="file"
                              name="image"
                              onChange={event => {
                                validation.setFieldValue(
                                  "image",
                                  event.target.files[0]
                                )
                              }}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.image &&
                                validation.errors.image
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.image &&
                            validation.errors.image ? (
                              <FormFeedback type="invalid">
                                {validation.errors.image}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col xs="12">
                            <div className="text-end d-flex justify-content-end align-items-center gap-3">
                              <button
                                type="button"
                                className="btn theme-btn-outline save-user mr-2"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                className="btn theme-btn save-user"
                              >
                                Save
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
          </div>
        </div>
      </Form>
      <ToastContainer />
    </React.Fragment>
  )
}

export default AddQuestion
